// extracted by mini-css-extract-plugin
module.exports = {"note":"style_note__fOClE"};